import React from 'react';
import { HomeNavigationEyebrow } from './HomeNavigationEyebrow';
import { HomeNavigationLogo } from './HomeNavigationLogo';
import { HomeNavigationDesktopMenu } from './HomeNavigationDesktopMenu';
import { HomeNavigationContact } from './HomeNavigationContact';
import { HomeNavigationMobileMenu } from './HomeNavigationMobileMenu';
export function HomeNavigation() {
  return <>
      <HomeNavigationEyebrow data-id="element-515" />

      {/* Main Navigation */}
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 py-2 px-4 shadow-sm" data-id="element-516">
        <div className="max-w-7xl mx-auto" data-id="element-517">
          <div className="flex justify-between items-center gap-8" data-id="element-518">
            <HomeNavigationLogo data-id="element-519" />
            <HomeNavigationDesktopMenu data-id="element-520" />
            <HomeNavigationContact data-id="element-521" />
            <HomeNavigationMobileMenu data-id="element-522" />
          </div>
        </div>
      </nav>
    </>;
}